// SPDX-License-Identifier: AGPL-3.0-or-later

import {getNativePlatformSync, isDesktop, isNativeWindows} from '@app/features/ui/utils/NativeUtils';
import type {SearchableSettingDescriptor} from '@app/features/user/components/settings_utils/search_index/SearchIndexTypes';
import {msg} from '@lingui/core/macro';

const SHARE_STEAM_GAME_ACTIVITY_DESCRIPTOR = msg({
	message: 'Share Steam game activity',
	comment: 'Settings search entry label. Names the settings search entry in the settings UI.',
});
const STEAM_DESCRIPTOR = msg({
	message: 'Steam',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
const GAME_ACTIVITY_DESCRIPTOR = msg({
	message: 'Game activity',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
const PLAYING_DESCRIPTOR = msg({
	message: 'Playing',
	comment: 'Settings search synonym. Used to match this term when the user types it in the settings search bar.',
});
const SHOW_STEAM_GAMES_ON_PROFILE_DESCRIPTOR = msg({
	message: 'Show games launched through Steam on your profile and in member lists',
	comment: 'Settings search entry description. One-line summary of what the settings search entry controls.',
});

export const gameActivityIndex: Array<SearchableSettingDescriptor> = [
	{
		id: 'desktop-share-steam-game-activity',
		tabType: 'game_activity',
		sectionId: 'game-activity',
		label: SHARE_STEAM_GAME_ACTIVITY_DESCRIPTOR,
		keywords: [STEAM_DESCRIPTOR, GAME_ACTIVITY_DESCRIPTOR, PLAYING_DESCRIPTOR],
		description: SHOW_STEAM_GAMES_ON_PROFILE_DESCRIPTOR,
		audience: 'primary',
		tags: ['desktop'],
		isVisible: () => isDesktop() && isNativeWindows(getNativePlatformSync()),
	},
];
